module.exports = __webpack_public_path__ + "img/icones_walnut.b603a3e0.png";